import {
  getNextPageParam,
  type Page,
  useInfiniteQuery,
  useQuery,
} from '@fv/client-core'
import type { AdminCarrierUser } from '@fv/models'
import type { AdminUserSearchResult } from '@fv/models/admin'

import { adminFetch } from '@/utils'

export const usersQueryKeys = {
  all: ['users'],
  user: (id: string) => [...usersQueryKeys.all, id],
  search: (search: string, limit: number, userType?: string) => [
    ...usersQueryKeys.all,
    search,
    limit,
    userType,
  ],
  carrierUsers: (carrierId: string) => [
    ...usersQueryKeys.all,
    'carrier',
    carrierId,
  ],
}

export function useFetchUsers(
  search: string,
  limit: number,
  userType?: string,
) {
  return useInfiniteQuery({
    queryKey: usersQueryKeys.search(search, limit, userType),
    queryFn: ({ pageParam = 0 }) =>
      adminFetch<Page<AdminUserSearchResult>>('/users', {
        query: {
          search,
          skip: pageParam,
          limit,
          ...(userType && { userType }),
        },
      }),
    initialPageParam: 0,
    getNextPageParam,
    refetchOnWindowFocus: false,
    enabled: search.length >= 2,
  })
}

export function useFetchCarrierUsers(carrierId: string, limit: number) {
  return useQuery(
    usersQueryKeys.carrierUsers(carrierId),
    () =>
      adminFetch<AdminCarrierUser[]>('/users/carrier', {
        query: { carrierId, limit },
      }),
    {
      enabled: !!carrierId,
      refetchOnWindowFocus: false,
    },
  )
}

type GenericUser = {
  firstName?: string
  lastName?: string
  email: string
  _id: string
}
export function useFetchGenericUser(id: string | undefined) {
  return useQuery(
    ['generic-user', id],
    () => adminFetch<GenericUser>(`/users/generic/${id}`),
    {
      enabled: !!id,
      staleTime: Infinity,
    },
  )
}
